import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import de from './locales/de.json';
import pl from './locales/pl.json';
import nl from './locales/nl.json';

// Supported languages
const supportedLanguages = ['en', 'de', 'pl', 'nl'];

// Lock locale from the URL BEFORE init.
// 1) /en, /de, /pl, /nl path prefixes (canonical, indexable localized routes)
// 2) legacy ?lng= query param (kept working for old bookmarks/links)
if (typeof window !== 'undefined') {
  try {
    const prefix = /^\/([a-z]{2})(\/|$)/i.exec(window.location.pathname)?.[1]?.toLowerCase();
    if (prefix && supportedLanguages.includes(prefix)) {
      window.localStorage.setItem('i18nextLng', prefix);
    }

    const qp = new URLSearchParams(window.location.search).get('lng');
    if (qp && supportedLanguages.includes(qp)) {
      const url = new URL(window.location.href);
      url.searchParams.delete('lng');
      const rest = /^\/([a-z]{2})(\/|$)/i.test(url.pathname) &&
        supportedLanguages.includes(url.pathname.split('/')[1])
        ? '/' + url.pathname.split('/').slice(2).join('/')
        : url.pathname;
      window.localStorage.setItem('i18nextLng', qp);
      // Redirect legacy ?lng= links to the clean localized path.
      window.location.replace(`/${qp}${rest === '/' ? '' : rest}${url.search}${url.hash}`);
    }
  } catch { /* ignore */ }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      pl: { translation: pl },
      nl: { translation: nl },
    },
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // querystring first so ?lng=de|nl|pl locks the locale on load
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    load: 'languageOnly', // Load 'de' instead of 'de-DE'
  });

// Keep <html lang> in sync so CSS `hyphens: auto` uses the right dictionary
// (critical for long German compound words like "Sporternährung").
if (typeof document !== 'undefined') {
  const applyLang = (lng: string) => {
    const base = (lng || 'en').split('-')[0];
    document.documentElement.setAttribute('lang', base);
  };
  applyLang(i18n.language);
  i18n.on('languageChanged', applyLang);
}

export default i18n;

